/**
 * Vertrouwensbadge bij een AI-draft. Drempels 80/60 zijn startwaarden;
 * na 2 weken ai_draft_confidence vs. edit_similarity correleren en bijstellen.
 * Gedeeld door ThreadDetail (email) en WhatsAppChat.
 *
 * Model-chip is admin-only: het provider-experiment (Claude vs OpenAI) meet
 * edit-gedrag van medewerkers, dus die mogen niet zien welk model schreef.
 */

import { useUserRole } from '../../hooks/useUserRole';

export function ConfidenceBadge({
  confidence,
  reason,
  model,
  diagnosticOnly = false,
}: {
  confidence: number | null;
  reason: string | null;
  model?: string | null;
  diagnosticOnly?: boolean;
}) {
  const { role } = useUserRole();

  if (confidence === null) return null;

  if (diagnosticOnly) return role === 'admin' ? (
    <span className="text-xs text-slate-500 cursor-help"
      title={`Modelinschatting ${confidence}%. Dit is geen bewijs van geslaagde uitvoering. ${reason || ''}${model ? ` Model: ${model}` : ''}`}>
      AI-info
    </span>
  ) : null;

  const level = confidence >= 80
    ? { label: 'Hoog vertrouwen', className: 'bg-emerald-100 text-emerald-700' }
    : confidence >= 60
      ? { label: 'Middel', className: 'bg-amber-100 text-amber-700' }
      : { label: 'Laag', className: 'bg-slate-100 text-slate-500' };

  return (
    <>
      <span
        className={`text-xs px-2 py-0.5 rounded font-medium cursor-default ${level.className}`}
        title={reason || undefined}
      >
        {level.label} ({confidence}%)
      </span>
      {role === 'admin' && model && (
        <span
          className="text-xs px-2 py-0.5 rounded font-medium cursor-default bg-slate-100 text-slate-500"
          title="AI-model (alleen zichtbaar voor admins — provider-experiment)"
        >
          {model.replace('claude-', '').replace('-20251001', '')}
        </span>
      )}
    </>
  );
}
